import {PUBLIC_RECAPTCHA_SITE_KEY} from '../configuration/index';

export async function getRecaptcha() {
  return new Promise((resolve, reject) => {
    // @ts-ignore
    grecaptcha.ready(function () {
      // @ts-ignore
      grecaptcha.execute(PUBLIC_RECAPTCHA_SITE_KEY, { action: "submit" }).then(function (t) {
        resolve(t);
      });
    });
  })
}